const plateformTitle = import.meta.env.VITE_APP_TITLE
export function changeTitle(pageTitle: string, title = plateformTitle) {
    if (pageTitle) {
        return `${pageTitle}-${title}`
    }
    return `${title}`
}
